export const TRANSFORMATION_STATUS = {
  DRAFT: 'DRAFT',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  AWAITING_CURATION: 'AWAITING_CURATION',
  IN_CURATION: 'IN_CURATION',
  PUBLISHED: 'PUBLISHED'
};

export const EVIDENCE_MAX_AGE = 10;
